export default ( Parameters ) => {
  let parameters = new URLSearchParams(Parameters)
  return parameters.toString()
}
